export default "__VITE_ASSET__KOkhW1$3__"